// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/clear_selected_for_display.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/clear_selected_for_display.proto.
 */
export const file_vision_generations_v1_clear_selected_for_display: GenFile = /*@__PURE__*/
  fileDesc("CjZ2aXNpb24vZ2VuZXJhdGlvbnMvdjEvY2xlYXJfc2VsZWN0ZWRfZm9yX2Rpc3BsYXkucHJvdG8SHHByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEilgEKHkNsZWFyU2VsZWN0ZWRGb3JEaXNwbGF5UmVxdWVzdBJTCgZwYXJhbXMYASABKAsyQy5wcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxLkNsZWFyU2VsZWN0ZWRGb3JEaXNwbGF5UmVxdWVzdC5QYXJhbXMaHwoGUGFyYW1zEhUKDWdlbmVyYXRpb25faWQYASABKAkigQEKH0NsZWFyU2VsZWN0ZWRGb3JEaXNwbGF5UmVzcG9uc2USVAoGcmVzdWx0GAEgASgLMkQucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5DbGVhclNlbGVjdGVkRm9yRGlzcGxheVJlc3BvbnNlLlJlc3VsdBoICgZSZXN1bHRiBnByb3RvMw");

/**
 * @generated from message protos.vision.generations.v1.ClearSelectedForDisplayRequest
 */
export type ClearSelectedForDisplayRequest = Message<"protos.vision.generations.v1.ClearSelectedForDisplayRequest"> & {
  /**
   * @generated from field: protos.vision.generations.v1.ClearSelectedForDisplayRequest.Params params = 1;
   */
  params?: ClearSelectedForDisplayRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.ClearSelectedForDisplayRequest.
 * Use `create(ClearSelectedForDisplayRequestSchema)` to create a new message.
 */
export const ClearSelectedForDisplayRequestSchema: GenMessage<ClearSelectedForDisplayRequest> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_clear_selected_for_display, 0);

/**
 * @generated from message protos.vision.generations.v1.ClearSelectedForDisplayRequest.Params
 */
export type ClearSelectedForDisplayRequest_Params = Message<"protos.vision.generations.v1.ClearSelectedForDisplayRequest.Params"> & {
  /**
   * @generated from field: string generation_id = 1;
   */
  generationId: string;
};

/**
 * Describes the message protos.vision.generations.v1.ClearSelectedForDisplayRequest.Params.
 * Use `create(ClearSelectedForDisplayRequest_ParamsSchema)` to create a new message.
 */
export const ClearSelectedForDisplayRequest_ParamsSchema: GenMessage<ClearSelectedForDisplayRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_clear_selected_for_display, 0, 0);

/**
 * @generated from message protos.vision.generations.v1.ClearSelectedForDisplayResponse
 */
export type ClearSelectedForDisplayResponse = Message<"protos.vision.generations.v1.ClearSelectedForDisplayResponse"> & {
  /**
   * @generated from field: protos.vision.generations.v1.ClearSelectedForDisplayResponse.Result result = 1;
   */
  result?: ClearSelectedForDisplayResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.ClearSelectedForDisplayResponse.
 * Use `create(ClearSelectedForDisplayResponseSchema)` to create a new message.
 */
export const ClearSelectedForDisplayResponseSchema: GenMessage<ClearSelectedForDisplayResponse> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_clear_selected_for_display, 1);

/**
 * @generated from message protos.vision.generations.v1.ClearSelectedForDisplayResponse.Result
 */
export type ClearSelectedForDisplayResponse_Result = Message<"protos.vision.generations.v1.ClearSelectedForDisplayResponse.Result"> & {
};

/**
 * Describes the message protos.vision.generations.v1.ClearSelectedForDisplayResponse.Result.
 * Use `create(ClearSelectedForDisplayResponse_ResultSchema)` to create a new message.
 */
export const ClearSelectedForDisplayResponse_ResultSchema: GenMessage<ClearSelectedForDisplayResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_clear_selected_for_display, 1, 0);

